import { Amplify } from 'aws-amplify';

export function configureAmplify(): void {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID;
  const region = import.meta.env.VITE_AWS_REGION;

  if (!userPoolId || !userPoolClientId || !region) {
    throw new Error(
      'Missing Cognito env vars: set VITE_COGNITO_USER_POOL_ID, VITE_COGNITO_USER_POOL_CLIENT_ID, VITE_AWS_REGION',
    );
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        signUpVerificationMethod: 'code',
        loginWith: { email: true },
      },
    },
  });
}
